module.exports = __webpack_public_path__ + "static/media/veronica.f65618a5.png";